var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.000078 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8301395 16.399961c-.00125.1577.06269.3094.1778.4219.11511.1125.27199.1765.43623.1781H14.5494c.1643-.0016.3212-.0656.4363-.1781.1151-.1125.179-.2642.1778-.4219V8.4001105H6.8301395Zm.83333-7.1998705H14.3301v6.9998705H7.6634695Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5384995 9.9994605h-.83338v4.9999005h.83338zM11.4135 9.9994605h-.8334v4.9999005h.8334zM13.2885 9.9994605h-.8334v4.9999005h.8334zM12.875 6.7999305v-1.19998c0-.33644-.247-.59999-.5625-.59999H9.6874995c-.3154 0-.5625.26355-.5625.59999v1.19998h-3.12496v.79999H16v-.79999zm-2.9166005-.99998H12.0417v.99998H9.9583995Z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.50003952,
    y: 0.49996051,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#000",
    strokeDasharray: "2, 2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAction);
export default __webpack_public_path__ + "static/media/delete_action.67e47a4e130ee841a4cdf9cd15ed8e70.svg";
export { ForwardRef as ReactComponent };